import routes from './routes';
import PrivateDiscussionsPage from './PrivateDiscussionsPage';

export default () => {
  routes();
  PrivateDiscussionsPage();
};
